import { render, staticRenderFns } from "./ButtonCreatePurchaseRequest.vue?vue&type=template&id=55063f80&"
import script from "./ButtonCreatePurchaseRequest.vue?vue&type=script&lang=ts&"
export * from "./ButtonCreatePurchaseRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports